import React from "react";
import { Building2 } from "lucide-react";

/* Office / location filter for the dispatch board. Options come from the
   /scheduling/locations/ endpoint when present, else are derived from the
   office data already on the loaded routes — so the board is never office-blind
   even before the backend Location dimension lands. Renders nothing when there
   is at most one office to choose between. */
export default function LocationFilter({ locations = [], value = "", onChange }) {
  if (!Array.isArray(locations) || locations.length < 2) return null;
  return (
    <label className="dispatch-locfilter" title="Filter by office / location">
      <Building2 size={14} className="dispatch-locfilter-icon" aria-hidden="true" />
      <span className="dispatch-locfilter-label">Location</span>
      <select
        className="dispatch-locfilter-select"
        value={value}
        onChange={(event) => onChange?.(event.target.value)}
        aria-label="Filter dispatch board by office or location"
      >
        <option value="">All locations</option>
        {locations.map((loc) => (
          <option key={loc.id} value={String(loc.id)}>
            {loc.name}
          </option>
        ))}
      </select>
    </label>
  );
}
